export const COUNTRIES_SHORT = {
  usa: 'us',
  mexico: 'mx'
};
